import { useEffect } from 'react';

import { useSiteStudio } from '../api/site';

/**
 * Keeps the tab title in the server's form ("<page> · <studio>", the home is
 * the studio alone) as the visitor moves between pages inside the site.
 * `undefined` while the page's own read is still loading leaves it as it is.
 */
export function usePageTitle(page: string | null | undefined): void {
  const studio = useSiteStudio().data?.name;
  useEffect(() => {
    if (!studio || page === undefined) return;
    document.title = page ? `${page} · ${studio}` : studio;
  }, [page, studio]);
}
